import React, { SyntheticEvent, useEffect, useState } from "react";
import * as S from "../../style/StyleComponentSection";
import noImage from "../../assets/images/no_image.svg";
import bookmark_white from "../../assets/icons/bookmark_white.svg";
// import bookmark_black from "../../assets/icons/bookmark_black.svg";
import bookmark_yellow from "../../assets/icons/bookmark_yellow.svg"
import { useSelector } from "react-redux";
import { RootState } from "../../redux/Store";
import {
    delete_favorite_portfolio,
    insert_favorite_portfolio,
    select_favorite_portfolio_ID_list
} from "../../Axios";
import { useNavigate } from "react-router-dom";

type Props = {
    portfolioList : PortfolioList[];
    handleSelectFavoritePortfolio : () => void;
    handleFavoritePortfolioBrand : () => void;
};

interface PortfolioList {
    ablack_comunity_ID            : number;
    ablack_comunity_brand_ID      : number;
    ablack_comunity_division_name : string;
    product_kor_name              : string;
    color_name                    : string;
    ablack_comunity_thumbnail_img : string;
    brand_kor_name                : string;
    product_eng_name              : string;
    ablack_comunity_status        : number;
};

const PortfolioBoard: React.FC<Props> = ({portfolioList, handleSelectFavoritePortfolio, handleFavoritePortfolioBrand}) => {
    // const dispatch = useDispatch();
    const navigate = useNavigate();
    const customerData = useSelector((state: RootState) => state.customerData);

    // const [modal, setModal] = useState<boolean>(false);
    // const [selectOneCommunityID, setSelectOneCommunityID] = useState<number>(0);
    const [favoriteIDList, setFavoriteIDList] = useState<number[]>([]);

    const addNoImage = (e: SyntheticEvent<HTMLImageElement, Event>) => {
        e.currentTarget.src = noImage;
    };

    // 좋아요 게시물 ID 리스트 가져오기
    useEffect(() => {
        handleSelectFavoriteIDList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [customerData.customer_ID]);

    const handleSelectFavoriteIDList = () => {
        if(!customerData.customer_ID) return;
        select_favorite_portfolio_ID_list(customerData.customer_ID).then(result => {
            setFavoriteIDList(result);
        });
    };

    return (
        <S.PortfolioContainer>
            {portfolioList.map((tmp, idx) =>
                <S.PortfolioBox
                    key={idx}
                    className="cursor-pointer"
                    onClick={(e: React.MouseEvent<HTMLDivElement>) => {
                        const target = e.target as HTMLElement;
                        if(target.classList.contains('favorite-icon') || target.classList.contains('favorite-img')) return;
                        navigate('/portfolio_select_one', {state : {ablack_comunity_ID : tmp.ablack_comunity_ID}});
                    }}
                >
                    <div className="image-box">
                        <img className="thumbnail-img" src={tmp.ablack_comunity_thumbnail_img} onError={addNoImage} alt="" />

                        <div className="favorite-icon">
                            <img className={`favorite-img ${favoriteIDList.includes(tmp.ablack_comunity_ID) ? "active-favorite-icon" : ""}`} src={favoriteIDList.includes(tmp.ablack_comunity_ID) ? bookmark_yellow : bookmark_white } alt="" 
                                onClick={() => {
                                    if(favoriteIDList.includes(tmp.ablack_comunity_ID)) {
                                        delete_favorite_portfolio(tmp.ablack_comunity_ID, customerData.customer_ID).then(result => {
                                            handleSelectFavoriteIDList();
                                            handleSelectFavoritePortfolio();
                                            handleFavoritePortfolioBrand();
                                        });
                                    } else {
                                        insert_favorite_portfolio(tmp.ablack_comunity_ID, customerData.customer_ID).then(result => {
                                            handleSelectFavoriteIDList();
                                            handleSelectFavoritePortfolio();
                                            handleFavoritePortfolioBrand();
                                        });
                                    }
                                }}
                            />
                        </div>

                    </div>
                    <div className="text-box">
                        <h3>{tmp.product_kor_name} - {tmp.color_name}</h3>
                        <span>{tmp.ablack_comunity_division_name}&nbsp;|&nbsp;</span>
                        <span>{tmp.brand_kor_name}</span>
                    </div>
                </S.PortfolioBox>
            )}
        
        </S.PortfolioContainer>
    )
};

export default PortfolioBoard;